import React, { useEffect, useMemo } from 'react'
import useTranslation from 'next-translate/useTranslation'
import DocumentAddTitle from 'tennders-transactions/views/common/DocumentTitle'
import AddSalesInvoiceDocumentButton from 'tennders-finance/sales-invoice/components/AddSalesInvoiceDocumentButton'
import useSession from 'tennders-auth/hooks/useSession'
import AddDocument from 'tennders-documents/components/AddDocument'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import AddOrderDocument from './AddOrderDocument'
import DocumentList from './DocumentList'

const ShippersDocuments = (props) => {
  const { transaction } = props
  const { t } = useTranslation()
  const { isMe, isBroker } = useSession()
  const isUploadable = (transaction?.loadVisible) || transaction?.isLoadOwner
  const load = useMemo(() => transaction?.matchedLoad, [JSON.stringify(transaction?.matchedLoad)])
  const [docs, setDocs] = React.useState(load?.documents || [])
  const hasOrderDoc = docs.find(doc => doc.type === 2)
  const { refreshTransaction } = useTransactions()

  const addDoc = (file) => {
    setDocs(prev => [...prev, file])
    refreshTransaction(transaction?.id)
  }

  useEffect(() => {
    setDocs(load?.documents || [])
  }, [load?.documents])

  if (transaction?.isCancelled) {
    return (
      <div className={isBroker() ? ' w-50' : 'w-100'}>
        <div className="pl-10 lh-1-3">
          <DocumentAddTitle
            t={t}
            title={isMe(load?.createdBy) ? t('transaction:yourDocuments') : t('transaction:shippersDocs')}
            type="shipper"
            isBroker={isBroker}
            transaction={transaction}
          />
          <DocumentList
            transaction={transaction}
            documents={docs}
            setDocuments={setDocs}
            poc={load?.company?.pointOfContact}
          />
        </div>
      </div>
    )
  }

  return (
    <div className={isBroker() ? ' w-50' : 'w-100'}>
      <div className="pl-10 lh-1-3">
        <DocumentAddTitle
          t={t}
          title={isMe(load?.createdBy) ? t('transaction:yourDocuments') : t('transaction:shippersDocs')}
          type="shipper"
          isBroker={isBroker}
          transaction={transaction}
        />
        {load
          && isUploadable
          && transaction?.isApproved
          && !transaction?.disabledActions?.includes('CREATE_SALES_INVOICE')
          && <AddSalesInvoiceDocumentButton transaction={transaction} />}
        {load && transaction?.loadVisible && (
          <>
            {!hasOrderDoc && isUploadable &&  (
              <AddOrderDocument
                title={t('document:addOrderConfirmationDocument')}
                type="order_confirm"
                handleUpload={(_, file) => addDoc(file)}
                id={transaction?.id}
              />
            )}
            <DocumentList
              documents={docs}
              setDocuments={setDocs}
              poc={load?.company?.pointOfContact}
              transaction={transaction}
            />
            {isUploadable && <AddDocument addDoc={addDoc} id={transaction?.id} type="shipper" />}
          </>
        )}
      </div>
    </div>
  )
}

export default ShippersDocuments
